import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { IOrdinalProps, ordinalColors } from './shared.styles';

export const FocusLine = styled.g``;
export const FocusSegment = styled.line`
    stroke: ${Variables.Colors.n100};
    stroke-width: 0.1px;
`;
export const FocusOuterDot = styled.circle`
    opacity: 0.3;
    stroke-width: 4px;
    stroke: ${ordinalColors};
    fill: transparent;
`;
export const FocusInnerDot = styled.circle`
    stroke-width: 2px;
    stroke: ${Variables.Colors.white};
    fill: ${ordinalColors};
`;
export const Tooltip = styled.div`
    display: flex;
    flex-direction: column;
`;
export const TooltipRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 22px;
    font-size: 15px;
`;
export const TooltipIcon = styled.span<IOrdinalProps>`
    margin-right: 8px;
    width: 8px;
    fill: ${ordinalColors};
`;
export const TooltipTitle = styled.span`
    flex-grow: 1;
    margin-right: 24px;
    white-space: nowrap;
`;
export const TooltipDate = styled(TooltipTitle)`
    color: ${Variables.Colors.n50};
`;
export const TooltipValue = styled.span`
    flex-grow: 0;
    white-space: nowrap;
`;
